export const reportExports = {
  edit: "Edit configuration",
  create: "Create export",
  save: "Save",
  saveFinished: "The configuration was saved successfully",
  saveFailed: "The configuration could not be saved",
  nameAlreadyTaken:
    "Export name already taken. Please choose a different name.",
  runExport: "Run export",
  runExportSuccess: "The export was started successfully",
  runExportError: "The export could not be started"
};
